import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material/styles';

import PageContainer from '../../../../components/layout/page-container/PageContainer';
import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import UsersListBig from '../../../../components/reusable/users-list/UsersListBig';
import withRouter from '../../../../hoc/with-router';
import { useNotFound } from '../../../../hooks/useNotFound';
import { useGetUserSubscribers } from '../../../../redux/api/users/usersApi';
import { useStyles } from './UserSubscribers.styles';

function UserSubscribers(props) {
  const { params } = props;
  const { t, i18n } = useTranslation();
  const {
    data: subscribers,
    isFetching,
    isError,
    error,
    refetch,
  } = useGetUserSubscribers(params.userId);
  useNotFound(!isFetching && subscribers === undefined);
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);

  useRegisterPageContainerError({
    errors: isError && error ? [error] : [],
    isLoading: isFetching && subscribers === undefined,
    hasData: Boolean(subscribers?.length),
    onRetry: handleRetry,
  });

  return (
    <PageContainer
      title={t('users.subscribers')}
      backButton
      onRefresh={() => void refetch()}>
      <div className={classes.subscribersWrapper}>
        <UsersListBig
          users={subscribers}
          showSearch
          withoutTabs
          isLoading={isFetching && subscribers === undefined}
          isError={isError}
        />
      </div>
    </PageContainer>
  );
}

export default withRouter(UserSubscribers);
